import React from 'react';
import clsx from 'clsx';
import phone from '../../icons/phone.svg';
import website from '../../icons/website.svg';
import './PharmaList.css';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import COS_LOGO_ROUND from '../../images/COS_LOGO_ROUND.png';

const PharmaItem = ({ selectedPharmacy, setSelectedPharmacy, pharmacy }) => {
  const isSelectedPharmacy =
    !isEmpty(selectedPharmacy) &&
    isEqual(get(selectedPharmacy, 'objectID'), get(pharmacy, 'objectID'));
  const pharmacyName = get(pharmacy, 'name', '');
  const pharmaWebsite = get(pharmacy, 'url', null);
  return (
    <div
      className={clsx('PharmaItem', {
        'PharmaItem--selected': isSelectedPharmacy,
      })}
      onClick={() => {
        setSelectedPharmacy(pharmacy);
      }}
      itemScope
      itemType="http://schema.org/Pharmacy"
    >
      <img
        className="PharmaItem__picture"
        src={isEmpty(get(pharmacy, 'image')) ? COS_LOGO_ROUND : pharmacy.image}
        loading="lazy"
        alt=""
        onError={(e) => (e.target.src = COS_LOGO_ROUND)}
      />
      <div className="PharmaItem__information">
        <p
          className={clsx('PharmaItem__information-title', {
            'PharmaItem__information-title--selected': isSelectedPharmacy,
          })}
          itemProp="legalName"
        >
          {pharmacyName}
        </p>
        <address className="PharmaItem__information-text" itemProp="address">
          {get(pharmacy, 'address.street', '')}
          <br />
          {get(pharmacy, 'address.city', '')}
        </address>
        <div className="PharmaItem__information-links">
          {get(pharmacy, 'telephone') && (
            <a
              className="PharmaItem__information-links-phone"
              href={'tel:' + pharmacy.telephone}
              itemProp="telephone"
            >
              <img
                className="PharmaItem__information-links-icons"
                src={phone}
                alt="phone"
                loading="lazy"
              />
              <span className="PharmaItem__information-links-caption">
                Appeler
              </span>
            </a>
          )}
          {get(pharmacy, 'telephone') && pharmaWebsite && (
            <div className="PharmaItem__information-links-separator">|</div>
          )}
          {pharmaWebsite && (
            <a
              className="PharmaItem__information-links-phone"
              href={get(pharmacy, 'url')}
              itemProp="url"
              target="_blank"
              rel="noopener"
            >
              <img
                className="PharmaItem__information-links-icons"
                src={website}
                alt={`Site Web - ${pharmacyName}`}
                loading="lazy"
              />
              <span className="PharmaItem__information-links-caption">
                Site web
              </span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default PharmaItem;
